import type { PasswordRequirement } from '../types/auth.types'

/**
 * Password requirements configuration
 */
export const PASSWORD_REQUIREMENTS: Array<PasswordRequirement> = [
  { test: (pw: string) => pw.length >= 8, text: 'At least 8 characters' },
  { test: (pw: string) => /[A-Z]/.test(pw), text: 'One uppercase letter' },
  { test: (pw: string) => /[a-z]/.test(pw), text: 'One lowercase letter' },
  { test: (pw: string) => /[0-9]/.test(pw), text: 'One number' },
]

/**
 * Validate password against all requirements
 */
export function validatePassword(password: string): {
  isValid: boolean
  requirements: Array<PasswordRequirement>
} {
  const requirements = PASSWORD_REQUIREMENTS.map((req) => ({
    ...req,
    met: req.test(password),
  }))

  return {
    isValid: requirements.every((req) => req.met),
    requirements,
  }
}

/**
 * Validate email format
 */
export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}
